import {createClient} from 'contentful';
import {getContentfulProxyConfig} from '../utils';

export const shouldUseMasterEnv = (): boolean =>
    window.dazn.features.getVariableBooleanAnonymous(
        'f_ar_landingpages_web_contentful_config',
        'useMaster'
    ) ?? false;

const contentFulConfigurations = {
    ContentfulSpaceId: 'vhp9jnid12wf',
    ContentfulEnvironment: shouldUseMasterEnv() ? 'master' : 'stage',
    ContentfulAccessToken: shouldUseMasterEnv()
        ? 'dARjM-2MN8QXYpPErOxwJS1XogcTiiL1DRfexCm0a2A'
        : '_wVOzTvLsLEr_U4gOBns9jeDpV_zlTL0DJBMITAtgbE',
    ContentfulHost: 'cdn.contentful.com'
};
const contentfulProxyConfig = getContentfulProxyConfig();

const space = contentFulConfigurations.ContentfulSpaceId;
const host =
    contentfulProxyConfig?.shouldUseProxy && contentfulProxyConfig?.proxyUrl
        ? contentfulProxyConfig?.proxyUrl
        : contentFulConfigurations.ContentfulHost;
const environment = contentFulConfigurations.ContentfulEnvironment;
const accessToken = contentFulConfigurations.ContentfulAccessToken;

const client = createClient({
    space,
    host,
    environment,
    accessToken
});

interface ContentfulServiceType {
    contentType: string;
    params?: Record<string, unknown> | undefined;
}

export const contentfulService = async ({
    contentType,
    params = {}
}: ContentfulServiceType): Promise<unknown> => {
    try {
        const locale = contentfulProxyConfig?.contentfulLocale;

        const response = await client.getEntries({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            content_type: contentType,
            locale,
            include: 10,
            ...params
        });

        return response;
    } catch (error) {
        return error;
    }
};
